import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Story from "@/pages/Story";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import OrderComplete from "@/pages/OrderComplete";
import Quiz from "@/pages/Quiz";
import Insights from "@/pages/Insights";
import LooseHerbsBotanicals from "@/pages/LooseHerbsBotanicals";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Header />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/loose-herbs-botanicals" element={<LooseHerbsBotanicals />} />
              <Route path="/our-story" element={<Story />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/policies/:type" element={<Policy />} />
              <Route path="/order-complete" element={<OrderComplete />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
